import React from 'react';
import { Link } from 'react-router-dom';
import { mockData } from '../mockData';

const Footer = () => {
  return (
    <footer className="dark-footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/privacy" className="footer-link">
            Privacy Policy
          </Link>
          <Link to="/terms" className="footer-link">
            Terms of Use
          </Link>
          <Link to="/disclaimer" className="footer-link">
            Risk Disclaimer
          </Link>
        </div>
        
        <div className="footer-copyright">
          <p>{mockData.companyName}</p>
          <p>© {mockData.currentYear}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
